import ApiClient from "../methods/api/apiClient";
import { getTenantInfo } from "../utils/domain";

export const Logo = (subdomainOverride) => async (dispatch) => {
  const tenantInfo = getTenantInfo();
  const slug =
    subdomainOverride || (tenantInfo.isTenant ? tenantInfo.slug : null);

  if (slug) {
    try {
      const res = await ApiClient.get(`tenants/public/${slug}`, {}, "", true);
      if (res?.success && (res?.data || res?.tenant)) {
        const tenantData = res.data || res.tenant;
        const webDetails = {
          ...tenantData,
          logo:
            tenantData?.logo ||
            tenantData?.logo_url ||
            tenantData?.fileUrl ||
            "/assets/img/logo.png",
          portal_title:
            tenantData?.portal_title ||
            tenantData?.company_name ||
            `${slug.toUpperCase()} Portal`,
          company_name:
            tenantData?.company_name ||
            tenantData?.portal_title ||
            slug.toUpperCase(),
          support_email:
            tenantData?.support_email ||
            tenantData?.contact_email ||
            "",
          support_phone:
            tenantData?.support_phone ||
            tenantData?.contact_phone ||
            "",
          address: tenantData?.address || null,
          isTenant: true,
          subdomain: slug,
        };

        if (webDetails.portal_title && typeof document !== "undefined") {
          document.title = `${webDetails.portal_title} | Equipment & Supplies`;
        }

        return dispatch({ type: "SET_WEB_DETAILS", data: webDetails });
      }
    } catch (err) {
      console.warn("Failed to load tenant public web details for", slug, err);
    }
  }

  // Fallback to default platform branding
  return dispatch({
    type: "Logo",
    data: {
      logo: "/assets/img/logo.png",
      url: "/assets/img/logo.png",
      portal_title: "Charles S. Smith & Associates",
      company_name: "Charles S. Smith & Associates",
      isTenant: false,
      subdomain: "",
    },
  });
};